const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    productMedia: document.querySelector('[data-productMedia]')
  };

  const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
  window.productMedia = mediaJSON;
  class TemplateProductJS {
    constructor() {
      var discountBox = document.querySelector('.discount-code');
      if (discountBox != null) {
        const that = this;
        discountBox.querySelector('[data-apply-discount]')?.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          that.checkDiscountCode(discountBox);
        })
      }
    }

    checkDiscountCode(discountBox) {
      var discountCode = discountBox.querySelector('[data-discountCode]').value;
      var variant_id = document.querySelector('[name="id"]').value;
      var qty = parseInt(document.querySelector('[name="quantity"]').value);
      var body = {};
      var checkout = {};
      checkout.discount_code = discountCode;
      checkout.presentment_currency = "USD";
      checkout.line_items = [{"variant_id": variant_id, "quantity": qty}];
      window.globalVariables.customer_email != null && (checkout.email = window.globalVariables.customer_email);
      body.checkout = checkout
      fetch("/payments/config", {
      }).then(response => {
          return response.json();
      }).then(response => {
        console.log('response',response.paymentInstruments.accessToken);
        fetch("/wallets/checkouts/?locale=en", {
        "credentials": "include",
        "headers": {
            "Content-Type": "application/json",
            "authorization": "Basic " + btoa(response.paymentInstruments.accessToken),
            "cache-control": "no-cache",
            "pragma": "no-cache",
            "Alt-Used": Shopify.shop,
        },
        "referrer": "https://"+Shopify.shop+"/",
        "body": JSON.stringify(body),
        "method": "POST"              
        }).then(response => {
            return response.json();
        }).then(response => {
          console.log('response',response);   
          if (response.errors != undefined) {
            if (response.errors.discount_code != undefined) {
              if (response.errors.discount_code[0].code == "discount_not_found") {
                discountBox.querySelector('.error-message').innerHTML = "Discount code is not valid!";
              } else {
                discountBox.querySelector('.error-message').innerHTML = response.errors.discount_code[0].message;
              }
            } else if(response.errors.applied_discount != undefined) {
              if (response.errors.applied_discount[0].code == "discount_limit_reached") {
                discountBox.querySelector('.error-message').innerHTML = "This discount has reached its usage limit";
              } else {
                discountBox.querySelector('.error-message').innerHTML = response.errors.applied_discount[0].message;
              }
            } else if(response.errors.line_items != undefined) {
              if (response.errors.line_items[0].quantity[0].code == "not_enough_in_stock") {
                discountBox.querySelector('.error-message').innerHTML = "Product is sold out!";
              } else {
                discountBox.querySelector('.error-message').innerHTML = response.errors.line_items[0].quantity[0].message;
              }
            } 
          } else if(response.checkout) {
            var checkoutObj = response.checkout;
            var checkoutDiscountCode = checkoutObj.discount_code;
            var checkoutURL = checkoutObj.web_url;

            if (checkoutDiscountCode == discountCode) {
              document.querySelector('.qty-add-to-cart-wrapper')?.classList.remove('d-none');
              document.querySelector('.discount-code')?.classList.add('d-none');
              document.querySelector('.oura-atc-btn')?.setAttribute('href', checkoutURL);
            }
          }       
        }).catch((error) => {
            console.log(error);
        });
      }).catch((error) => {
          console.log(error);
      });
    }
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();
